import axios from 'axios';

const BASE_URL = 'https://mototaksi.az:9999/api/v6/bilet';

const BiletController = {
  // Bütün biletləri gətir
  getAllBilets: async () => {
    try {
      const response = await axios.get(BASE_URL);
      return response.data;
    } catch (error) {
      console.error('Biletlər alınarkən xəta:', error);
      throw error;
    }
  },

  // Bilet ID ilə məlumat gətir
  getBiletById: async (biletId) => {
    try {
      const response = await axios.get(`${BASE_URL}/${biletId}`);
      return response.data;
    } catch (error) {
      console.error(`ID ${biletId} üçün bilet alınarkən xəta:`, error);
      throw error;
    }
  },

  // İstifadəçiyə aid biletlər
  getBiletsByUserId: async (userId) => {
    try {
      const response = await axios.get(`${BASE_URL}/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error(`User ID ${userId} üçün biletlər alınarkən xəta:`, error);
      throw error;
    }
  },

  // Lotoreyaya aid biletlər
  getBiletsByLotoreyaId: async (lotoreyaId) => {
    try {
      const response = await axios.get(`${BASE_URL}/lotoreya/${lotoreyaId}`);
      return response.data;
    } catch (error) {
      console.error(`Lotoreya ID ${lotoreyaId} üçün biletlər alınarkən xəta:`, error);
      throw error;
    }
  },

  // Bilet al (buy)
  buyBilet: async (lotoreyaId, userId) => {
    try {
      const response = await axios.post(`${BASE_URL}/buy`, null, {
        params: { lotoreyaId, userId },
      });
      return response.data;
    } catch (error) {
      console.error(`Bilet alışı zamanı xəta (lotoreyaId=${lotoreyaId}, userId=${userId}):`, error.response?.data || error.message);
      throw error;
    }
  },

  // Bileti sil
  deleteBiletById: async (biletId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/${biletId}`);
      return response.data;
    } catch (error) {
      console.error(`Bilet ID ${biletId} silinərkən xəta:`, error);
      throw error;
    }
  }
};

export default BiletController;
